<template>
  <div class="ll-validate-watcher" />
</template>
<script>
export default {
  name: "LlValidateWatcher",
  props: {
    errors: {
      type: [String, Array, Boolean],
      default: null,
    },
  },
  watch: {
    errors: {
      immediate: true,
      handler() {
        this.$emit("input", this.errors);
      },
    },
  },
};
</script>